import { z } from 'zod';
import { FlowPricingMode } from '../flow/pricingMode.js';
import { FlowBlockType } from '../flowDefinition/blocks/type.js';
import { FlowRunState } from '../flowRun/flowRunState.js';
export const FlowMeteredRecordSchema = z.object({
    flowRunBlockMetricId: z.uuid().nullable(),
    flowRunState: z.enum(FlowRunState).nullable(),
    eventName: z.string(),
    metricValue: z.number(),
    organizationId: z.uuid(),
    practiceId: z.uuid().nullable(),
    flowRunId: z.uuid(),
    flowId: z.uuid(),
    flowDefinitionId: z.uuid(),
    agentId: z.uuid().nullable(),
    blockType: z.enum(FlowBlockType).nullable(),
    blockId: z.string().nullable(),
    metadata: z.record(z.string(), z.string()),
    pricingMode: z.enum(FlowPricingMode),
    useCase: z.string().nullable(),
    flowRunStartTime: z.iso.datetime().nullable(),
});
//# sourceMappingURL=meteredRecord.js.map